import React, { useState } from 'react';

const SearchInput = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        onSearch && onSearch(e.target.value);
    };

    const handleSearch = () => {
        onSearch && onSearch(searchTerm);
    };

    const handleClear = () => {
        setSearchTerm('');
        onSearch && onSearch('');
    };

    return (<>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <div className="input-icon">
                        <span className="input-icon-addon" onClick={handleSearch}>
                            <i className="fa fa-search"></i>
                        </span>
                        <input type="text" className="form-control" value={searchTerm}
                            onChange={handleInputChange}
                            placeholder="Search..." />
                        {searchTerm && (
                            <span className="input-icon-addon" onClick={handleClear}>
                                <i className="fa fa-times"></i>
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </>

    );
};

export default SearchInput;